import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';

export async function confirmOrder(
    {
        orderId,
        stripePaymentMethodId,
    }: {
        orderId: string;
        stripePaymentMethodId?: string;
    },
    { clientSdk }: DependenciesPayload,
): Promise<ConfirmOrder> {
    const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
        Awaited<ReturnType<typeof clientSdk.commerce.order.confirmOrder>>,
        ConfirmOrder
    > = (confirmOrder) => {
        return {
            newSubscription:
                'newSubscription' in confirmOrder
                    ? confirmOrder.newSubscription
                    : undefined,
            cancelSubscription:
                'cancelSubscription' in confirmOrder
                    ? confirmOrder.cancelSubscription
                    : undefined,
            subscriptionPlanSwitch:
                'subscriptionPlanSwitch' in confirmOrder
                    ? confirmOrder.subscriptionPlanSwitch
                    : undefined,
        };
    };
    const confirmOrder = mapClientSdkToWebSdk(
        await clientSdk.commerce.order.confirmOrder(orderId),
    );
    return confirmOrder;
}

export type ConfirmOrder = {
    newSubscription?: {
        subscriptionId: string;
    };
    cancelSubscription?: {
        cancellationReference: string;
        cancellationType: string;
    };
    subscriptionPlanSwitch?: {
        subscriptionId: string;
    };
};
